import {condition, request} from "../../../res/rest/restRequest";
import HttpClient from "../../services/http/HttpClient";
import {env} from "../../../res/config/env";
import {api} from "../../../res/rest/api";
import previousPaymentsRequest from "../../services/rest/request/checkout/previousPaymentsRequest";

const getOverdueRequest = async (session) => {
    const req = request.model("web_bp_overdue_v")
        .select("overdue")
        .filter(condition.eq("c_bpartner_ID", session.bPartnerID))
    const resp = await HttpClient.client.get(req.buildRequest(env.API_URL), api.auth(session));
    return resp.data.records[0];
}

const getPreviousPayments = async (session, orderID) => {
    const previousPaymentsRes = await previousPaymentsRequest()
        .orderID(orderID)
        .sendIt(session);
    return previousPaymentsRes?.[0]?.total_payamt ?? 0;
}

const getOverDue = async (session, bp) => {
    if(bp?.PaymentRule?.id === "K"
        || bp?.SOCreditStatus?.id === "S") {

        const overdueRes = await getOverdueRequest(session);
        return overdueRes?.overdue ?? 0;
    }
    return 0;
}

const getPaymentDetailsAction = async (session, bPartner, orderID) => {

    const previousPayment = await getPreviousPayments(session, orderID);
    const overDue = await getOverDue(session, bPartner);

    return { previousPayment, overDue }
}

export default getPaymentDetailsAction